import { render } from "./Empresa.vue?vue&type=template&id=2082fff5&scoped=true"
import script from "./Empresa.vue?vue&type=script&lang=js"
export * from "./Empresa.vue?vue&type=script&lang=js"

import "./Empresa.vue?vue&type=style&index=0&id=2082fff5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2082fff5"]])

export default __exports__